export default __webpack_public_path__ + "static/media/gift-white.a46eca8d.svg";